// Single source of truth for location ordering across the Hub. Every location picker
// (Bookings/Dashboard filter, Site information, Opening hours, Users, Applications,
// Experiences, Contacts) shows the same alphabetical order, so the list never drifts
// between pages. Apply this at each data source (GraphQL wrapper, user store, Contacts BFF)
// and let the views render the result as-is.
export const sortLocationsByName = (locations) =>
    [...(locations || [])].sort((a, b) => (a?.name || "").localeCompare(b?.name || ""));
